module.exports = __webpack_public_path__ + "img/C23.589c760b.png";